var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB0",
    d: "M19.935 6.879a1.327 1.327 0 0 0-1.07-.9l-5.057-.735-2.26-4.567c-.447-.903-1.926-.903-2.374 0l-2.26 4.567-5.046.735A1.326 1.326 0 0 0 .8 6.88a1.32 1.32 0 0 0 .335 1.356l3.66 3.567-.864 5.032a1.324 1.324 0 0 0 1.924 1.395l4.507-2.376 4.521 2.376c.445.238.985.198 1.394-.1.407-.297.61-.798.526-1.295l-.862-5.033 3.66-3.566c.36-.35.49-.878.334-1.357"
  })));
};
export default SvgStar;